/* RuleIndexRenderer.js */

"use strict";

class RuleIndexRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("default-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("RuleIndex", (this._onRuleIndex = this._onRuleIndex.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("RuleIndex");
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setRuleIndex(this._model.getRuleIndex());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onRuleIndex(newVal) {
        this._setRuleIndex(newVal);
    }

    _setRuleIndex(val) {
        this._rootElem.innerHTML = parseInt(val, 10) + 1;
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = RuleIndexRenderer;
